import { AccordionSummary, styled } from "@mui/material";

const AccessAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
  flexDirection: "row-reverse",
  borderBottom: "none",
  width: "100%",
  "& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
    color: "white",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(0deg)",
  },
}));

export default AccessAccordionSummary;
